export default Object.freeze({
  None: 0,
  NoChildren: 1,
  AllSucceeded: 2,
  SomeFailed: 3,
  AllFailed: 4,
  TimedOut: 5,
});
